/**
 * Global scroll unlock safety net (all PDPs + cart drawer).
 * Runs without ES modules so it still works if dialog.js is delayed/cached.
 * Clears body position:fixed / overflow:hidden left after ATC → Back.
 */
(function () {
  'use strict';

  function unlock() {
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return;

    var top = body.style.top;
    var locked =
      body.style.position === 'fixed' ||
      body.style.top !== '' ||
      body.style.width !== '' ||
      body.style.overflow === 'hidden' ||
      html.style.overflow === 'hidden' ||
      html.hasAttribute('scroll-lock');

    if (!locked) return;

    var y = top ? Math.abs(parseInt(top, 10)) || 0 : window.scrollY || window.pageYOffset || 0;

    body.style.width = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.overflow = '';
    html.style.overflow = '';
    html.removeAttribute('scroll-lock');

    window.scrollTo(0, y);
  }

  function recover() {
    document.querySelectorAll('dialog[open]').forEach(function (dialog) {
      try {
        dialog.close();
      } catch (e) {
        /* ignore */
      }
      dialog.classList.remove('dialog-closing');
    });
    unlock();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) recover();
    else if (!document.querySelector('dialog[open]')) unlock();
  });

  window.addEventListener('pagehide', unlock);

  window.addEventListener('popstate', unlock);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && !document.querySelector('dialog[open]')) {
      unlock();
    }
  });
})();
